// @flow

// Types
import type {
  Asset,
  Category,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_CATEGORY,
} from 'fc-model-assets'

// Selectors
import assetsById$ from '../assets'

// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'
import _filter from 'lodash/filter'

// Local Types
type Args = {
  assets$?: Selector$<Array<Asset>>,
  category: Category,
}

// Default Assets Selector
const allAssets$: Selector$<Array<Asset>> = createSelector(
  [assetsById$],
  _map,
)

// Exports
export default function makeAssetsOfCategory ({
  assets$ = allAssets$,
  category,
  }: Args): Selector$<Array<Asset>> {
  return createSelector(
    [assets$],
    function (assets: Array<Asset>): Array<Asset> {
      return _filter(assets, { [PROP_CATEGORY]: category })
    }
  )
}
